// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import { Grid, Header, Icon, Menu, Ref } from "semantic-ui-react";
import "./ApplicationLauncherMenuList.less";
import { ApplicationList } from "../ApplicationList";
import { useState } from "../../hooks";
import { getApplicationClassName } from "../utils/className";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const className = getApplicationClassName("launcher", "menu", "list");
export const ApplicationLauncherMenuList = props => {
  const {
    header,
    icon,
    items,
    actions,
    loading,
    fetching,
    placeholder,
    only,
    sortable,
    onSort
  } = props;
  const [position, setPosition] = useState(0);
  const [scroll, setScroll] = useState(0);
  const [height, setHeight] = useState(0);
  const viewportRef = React.useRef(null);

  // const viewportRect = useRect(viewportRef);
  // const viewportScroll = useScroll(viewportRef);

  React.useEffect(() => {
    React.startTransition(() => {
      setHeight(viewportRef.current?.clientHeight);
    });
  }, [viewportRef.current?.clientHeight, setHeight]);
  React.useEffect(() => {
    React.startTransition(() => {
      setScroll(viewportRef.current?.scrollHeight);
    });
  }, [viewportRef.current?.scrollHeight, setScroll]);
  const scrollTo = React.useCallback(top => {
    if (viewportRef) {
      const {
        current
      } = viewportRef;
      if (current) {
        current.scrollTo({
          top,
          behavior: "smooth"
        });
      }
    }
  }, []);
  const handleScroll = React.useCallback(({
    target: {
      scrollTop
    }
  }) => {
    React.startTransition(() => {
      setPosition(scrollTop);
    });
  }, [setPosition]);
  const handleScrollUp = React.useCallback(() => {
    if (scroll !== 0) {
      React.startTransition(() => {
        scrollTo(Math.ceil(Math.max(position - height, 0)));
      });
    }
  }, [scroll, height, position, scrollTo]);
  const handleScrollDown = React.useCallback(() => {
    if (scroll !== height) {
      React.startTransition(() => {
        scrollTo(Math.floor(Math.min(position + height, scroll)));
      });
    }
  }, [scroll, height, position, scrollTo]);
  const scrollUp = React.useMemo(() => /*#__PURE__*/_jsx(Menu.Item, {
    disabled: scroll === height || position === 0 || loading,
    onClick: handleScrollUp,
    children: /*#__PURE__*/_jsx(Icon, {
      name: "chevron up",
      size: "big",
      fitted: true
    })
  }), [scroll, height, position, loading, handleScrollUp]);
  const scrollDown = React.useMemo(() => /*#__PURE__*/_jsx(Menu.Item, {
    disabled: scroll === height || position + height >= scroll - 1 || loading,
    onClick: handleScrollDown,
    children: /*#__PURE__*/_jsx(Icon, {
      name: "chevron down",
      size: "big",
      fitted: true
    })
  }), [scroll, height, position, loading, handleScrollDown]);
  const headerMenu = React.useMemo(() => /*#__PURE__*/_jsxs(Menu, {
    borderless: true,
    children: [/*#__PURE__*/_jsx(Menu.Menu, {
      position: "left",
      children: /*#__PURE__*/_jsxs(Menu.Item, {
        header: true,
        children: [/*#__PURE__*/React.isValidElement(icon) ? icon : icon && /*#__PURE__*/_jsx(Icon, {
          name: fetching ? "spinner" : icon,
          loading: fetching
        }), header]
      })
    }), /*#__PURE__*/_jsx(Menu.Menu, {
      position: "right",
      children: scrollUp
    })]
  }), [icon, fetching, header, scrollUp]);
  const footerMenu = React.useMemo(() => /*#__PURE__*/_jsxs(Menu, {
    borderless: true,
    children: [/*#__PURE__*/_jsx(Menu.Menu, {
      position: "left",
      children: actions
    }), /*#__PURE__*/_jsx(Menu.Menu, {
      position: "right",
      children: scrollDown
    })]
  }), [actions, scrollDown]);
  const empty = React.useMemo(() => /*#__PURE__*/_jsxs(Header, {
    icon: true,
    children: [/*#__PURE__*/React.isValidElement(icon) ? icon : icon && /*#__PURE__*/_jsx(Icon, {
      className: "outline",
      name: icon
    }), placeholder]
  }), [icon, placeholder]);
  const content = React.useMemo(() => /*#__PURE__*/_jsx(ApplicationList, {
    items: items,
    loading: loading,
    placeholder: empty,
    sortable: sortable,
    onSort: onSort
  }), [items, loading, empty, sortable, onSort]);
  return React.useMemo(() => /*#__PURE__*/_jsxs(Grid.Column, {
    className: className,
    only: only,
    children: [/*#__PURE__*/_jsx(Grid.Row, {
      verticalAlign: "top",
      children: headerMenu
    }), /*#__PURE__*/_jsx(Ref, {
      innerRef: viewportRef,
      children: /*#__PURE__*/_jsx(Grid.Row, {
        onScroll: handleScroll,
        verticalAlign: "middle",
        children: content
      })
    }), /*#__PURE__*/_jsx(Grid.Row, {
      verticalAlign: "bottom",
      children: footerMenu
    })]
  }), [only, content, headerMenu, footerMenu, handleScroll]);
};